'use client';

import React from 'react';
import tunnelFactory from 'tunnel-rat';

export type PortalName = string;

type Tunnel = ReturnType<typeof tunnelFactory>;

const registry = new Map<PortalName, Tunnel>();

export function getTunnel(name: PortalName): Tunnel {
  if (!registry.has(name)) {
    registry.set(name, tunnelFactory());
  }
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return registry.get(name)!;
}

export function clearTunnel(name: PortalName): void {
  registry.delete(name);
}

export function listTunnels(): PortalName[] {
  return Array.from(registry.keys());
}
